import { NotificationSettingsPolicyEnum } from '@app/modules/audit/modules/aod/aod.types';
import { z } from 'zod';

export type MessageFormatter = (msg: { id: string; defaultMessage: string }) => string;

const reportTypeMsg = {
  id: 'audit.aod.basicInfo.reportTypeRequired',
  defaultMessage: 'El tipo de reporte es obligatorio',
};
const nameRequiredMsg = {
  id: 'audit.aod.basicInfo.nameRequired',
  defaultMessage: 'El nombre es obligatorio',
};
const nameTooLongMsg = {
  id: 'audit.aod.basicInfo.nameTooLong',
  defaultMessage: 'El nombre es demasiado largo',
};
const triggerMsg = {
  id: 'audit.aod.basicInfo.triggerRequired',
  defaultMessage: 'El trigger es obligatorio',
};
const invalidUserIdMsg = {
  id: 'audit.aod.basicInfo.invalidUserId',
  defaultMessage: 'ID de usuario inválido',
};
const notificationPolicyMsg = {
  id: 'audit.aod.basicInfo.notificationPolicyRequired',
  defaultMessage: 'La política de notificación es obligatoria',
};

export function getBasicInfoSchema(t: MessageFormatter) {
  return z.object({
    reportType: z.string().min(1, t(reportTypeMsg)),
    name: z.string().min(1, t(nameRequiredMsg)).max(255, t(nameTooLongMsg)),
    trigger: z.string().min(1, t(triggerMsg)),
    active: z.boolean(),
    notificationSettings: z.object({
      policy: z.nativeEnum(NotificationSettingsPolicyEnum, {
        message: t(notificationPolicyMsg),
      }),
    }),
    managers: z
      .array(
        z.object({
          id: z.string().uuid(t(invalidUserIdMsg)),
        }),
      )
      .optional(),
  });
}

/** @deprecated Use getBasicInfoSchema(t) for translated messages */
export const basicInfoSchema = getBasicInfoSchema((msg) => msg.defaultMessage);

export type BasicInfoValues = z.infer<ReturnType<typeof getBasicInfoSchema>>;
